import * as React from "react";
import DatePicker from "material-ui/DatePicker";

import * as moment from "moment-timezone";

import WalletSpendContainer from "app/components/AppComponents/Fraud/WalletSpendContainer";

type State = {
  filterDate: Date;
};

export default class WalletSpend extends React.Component<any, State> {
  constructor(props: any) {
    super(props);

    const filterDate = new Date();
    filterDate.setDate(filterDate.getDate() - 1);

    this.state = {
      filterDate
    };
  }

  fromAndToForDate = (date: Date) => {
    const from = moment(date)
      .startOf("day")
      .tz("Africa/Johannesburg")
      .format();
    const to = moment(date)
      .endOf("day")
      .tz("Africa/Johannesburg")
      .format();

    return { from, to };
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Fraud > Wallet Spend",
      description: "Wallet payments to merchants"
    });
  }

  render() {
    const { from, to } = this.fromAndToForDate(this.state.filterDate);
    const name = "fraud.walletspend";
    return (
      <section className="padded">
        <DatePicker
          name={`${name}.datefilter`}
          onChange={(e, date) => {
            this.setState({ filterDate: date });
          }}
          defaultDate={this.state.filterDate}
        />
        <WalletSpendContainer
          name={name}
          createdAtFrom={from}
          createdAtTo={to}
        />
      </section>
    );
  }
}
